import React from "react";
import { API_MOTO, HandleApi } from "../contants/general.constants";
import { Card } from "./card/card";

const FALLBACK = {
 moto: "We forge your way into the future!",
 description:
  "Like a blacksmith shapes raw metal into something precise and lasting, we shape raw ideas into robust, elegant software — heated by creativity, hammered by engineering discipline, and tempered for the real world.",
};

export function MotoComponent() {
 const [moto, setMost] = React.useState(null);

 HandleApi(API_MOTO, setMost, setMost);

 const cardContent = {
  header: "Our purpose",
  key: "purpose",
  content: {},
 };

 if (moto) {
  const moto_res = moto.results[0];
  cardContent.content = {
   title: moto_res.moto || FALLBACK.moto,
   text: moto_res.description || FALLBACK.description,
  };
 }

 return <Card key="purpose" props={{ card: cardContent, id: "purpose" }} />;
}
